exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-7b40d0b8] {\n  color: #0275be;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #99aabb;\n}\n.pop-form button.main[data-v-7b40d0b8] {\n  background: #0480c6;\n  color: white;\n  min-width: 120px;\n  border: 0;\n  box-sizing: border-box;\n  height: 29px;\n  border-radius: 15px;\n  font-size: 12px;\n  font-weight: bold;\n}\n.edit.pop-btn[data-v-7b40d0b8] {\n  margin-left: 16px;\n  background: #0480c6 !important;\n  border-color: transparent;\n  color: white !important;\n}", ""]);

// exports
